/* eslint-disable max-len */
import type { FunctionComponent } from 'react';
import { type RebrandingContextProps, useRebranding } from '../../../contexts/RebrandingContext';

const RegulationsMP: FunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#009EE3" fillRule="nonzero">
        <g>
          <g>
            <g>
              <path
                d="M11.999.632l9.751 5.67v3.447l-2.244.001v7.52h1.24l2.24 5.265H1.164l2.071-5.265h1.267V9.766l-2.253.004V6.302l9.749-5.67zm7.755 18.138H4.258l-.891 2.265h17.35l-.963-2.265zm-1.748-1.5V9.751l-5.257.006v7.511h5.257zm-6.757-7.51l-5.246.006v7.503h5.246V9.76zm.75-7.392L3.75 7.165v1.104l16.5-.018V7.165l-8.251-4.797z"
                transform="translate(-28 -405) translate(20 383) translate(0 14) translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const YellowRegulations: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.24994 6.30194L11.9989 0.632324L21.7499 6.30189V9.74907L19.5062 9.75158V17.27H20.746L22.9853 22.5354H1.16479L3.23602 17.27H4.50335V9.76834L2.24994 9.77085V6.30194ZM4.25785 18.77L3.36673 21.0354H20.7174L19.7539 18.77H4.25785ZM18.0062 17.27V9.75325L12.7489 9.75913V17.27H18.0062ZM6.00335 9.76666L11.2489 9.7608V17.27H6.00335V9.76666ZM3.74994 7.16481V8.26918L20.2499 8.25075V7.16486L11.999 2.36749L3.74994 7.16481Z" fill="#3483FA" />
  </svg>
);

const RegulationsCongratsMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.25018 6.30194L11.9991 0.632324L21.7502 6.30189V9.74907L19.5064 9.75158V17.27H20.7462L22.9856 22.5354H1.16504L3.23627 17.27H4.50359V9.76834L2.25018 9.77085V6.30194ZM4.2581 18.77L3.36697 21.0354H20.7176L19.7541 18.77H4.2581ZM18.0064 17.27V9.75325L12.7492 9.75913V17.27H18.0064ZM6.00359 9.76666L11.2492 9.7608V17.27H6.00359V9.76666ZM3.75018 7.16481V8.26918L20.2502 8.25075V7.16486L11.9992 2.36749L3.75018 7.16481Z" fill="#00A650" />
  </svg>

);

export const RegulationsSVG: FunctionComponent = () => {
  const { isRebrandingEnabled } = useRebranding() as RebrandingContextProps;

  return isRebrandingEnabled ? <YellowRegulations /> : <RegulationsMP />;
};

export const RegulationsCongratsSVG: FunctionComponent = () => (<RegulationsCongratsMP />);
